import StyledSvg from '@gef-ui/material-svg-shared/StyledSvg';
import * as React from 'react';
const SvgClock2FidelityLow = (props)=>{
    const id = React.useId();
    return /*#__PURE__*/ React.createElement(StyledSvg, {
        xmlns: "http://www.w3.org/2000/svg",
        width: 56,
        height: 56,
        fill: "none",
        viewBox: "0 0 56 56",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: `url(#clock-2-fidelity-low_svg__a-${id})`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#E4EFFA",
        d: "M56 28C56 12.536 43.464 0 28 0S0 12.536 0 28s12.536 28 28 28 28-12.536 28-28"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M27.551 10.063c9.67 0 17.548 7.819 17.548 17.548s-7.878 17.488-17.548 17.488-17.488-7.819-17.488-17.488 7.819-17.548 17.488-17.548"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#F2F9FF",
        d: "M21.994 41.034s17.13-2.089 19.1-18.801c1.97-16.713 3.462 7.938 3.462 7.938l-3.88 8.356-12.534 6.566-6.267-1.79-1.493-1.194z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#A8C3DD",
        strokeMiterlimit: 10,
        strokeWidth: 4.5,
        d: "M27.551 10.063c9.67 0 17.548 7.819 17.548 17.548s-7.878 17.488-17.548 17.488-17.488-7.819-17.488-17.488 7.819-17.548 17.488-17.548Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        d: "M27.554 29.171a1.492 1.492 0 1 0 0-2.984 1.492 1.492 0 0 0 0 2.984"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#E13632",
        stroke: "#E13632",
        strokeMiterlimit: 10,
        strokeWidth: 2,
        d: "M27.55 26.71c-.24 0-.359-.12-.359-.298v-8.954c0-.179.12-.298.299-.298h.06c.179 0 .298.12.298.298v8.954c0 .179-.12.298-.299.298ZM27.43 27.781l.059-.12c.06-.119.18-.238.358-.178l6.447 2.208c.119.06.238.18.178.358l-.06.12c-.059.119-.178.238-.357.179l-6.506-2.209c-.06-.06-.18-.238-.12-.358Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#50769A",
        d: "M44.077 17.063s7.178 9.802-.058 20.807c0 0-4.61 8.599-16.456 8.943 0 0 25.092-4.013 16.514-29.75"
    }), /*#__PURE__*/ React.createElement("circle", {
        cx: 14.438,
        cy: 17.5,
        r: 7.438,
        fill: "#4C875B"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m12.002 19.241 5.1-5.1 1.614 1.616-5.1 5.1z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "m13.618 20.858-3.46-3.46 1.615-1.615 3.46 3.46z"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: `clock-2-fidelity-low_svg__a-${id}`
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M0 0h56v56H0z"
    }))));
};
export default SvgClock2FidelityLow;
